export enum SettlementTypeEnums {
    usedSale = 2,
    newSale = 1,
    none = 0,
}